// components/InputField.jsx
import React from "react";
import PropTypes from "prop-types";

function InputField({ icon, name, value, onChange, placeholder, type = "text" }) {
    return (
        <div className="relative">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[var(--parent-accent)] dark:text-emerald-300">
                {icon}
            </div>
            <input
                type={type}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="w-full pl-10 pr-4 py-3 rounded-lg bg-white text-gray-800 border border-[var(--parent-input-border)] focus:outline-none focus:ring-2 focus:ring-[var(--parent-primary)] dark:bg-gray-900 dark:text-gray-100 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-emerald-400"
                required
            />
        </div>
    );
}

InputField.propTypes = {
    icon: PropTypes.element,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
};

export default InputField;
